$(document).ready(function () {
    let totalSteps = $('.step').length;
    let currentStep = 1;
    function updateProgress() {
        let progress = (currentStep / totalSteps) * 100;
        $('.progress-bar').css('width', progress + '%');
    }
    function updateButtons() {
       if(window.innerWidth <= 767){
        if(previousCurrentStep === 1) {
          $('.prev').hide();
          $('button.Return_product').show();
        }else {
            $('.prev').show();
        }
       }else{
        if(currentStep === 1) {
          $('.prev').hide();
          $('button.Return_product').show();
        }else {
            $('.prev').show();
        }
       }
       

        if (currentStep === totalSteps) {
            $('.next').hide();
            $('.submit').show();
            $('.pdp-customization.No_metafeild').addClass('active_last');
            $('.pdp-customization.No_metafeild .final_review').show();
            $('.pdp-customization.No_metafeild .custom_atc').show();
          
        } else {
            $('.next').show();  
            $('.pdp-customization.No_metafeild').removeClass('active_last');
            $('.pdp-customization.No_metafeild .final_review').hide();
            $('.submit').hide();
            $('.pdp-customization.No_metafeild .custom_atc').hide();
        }
    }
     
    function initMobileSlider() {
      if (window.innerWidth <= 767) {
         $('.mobile_step_3').hide();
         $('.mobile_step_3 , .mobile_step_2 , .form-card.Position_Card').hide();
      }else{
         $('.mobile_step_3').hide();
         $('.mobile_step_2 , .form-card.Position_Card').show();   
      }
    }
  $(document).ready(function() {
   initMobileSlider()
  });
  $(window).resize(function() {
   initMobileSlider();
  });
     
    let previousCurrentStep = 1;
    function update_class(params) {  
           if (currentStep < totalSteps) {
                $('button.Return_product').hide();
                currentStep++;
                $('.step').removeClass('active');
                $('#step' + currentStep).addClass('active');
                updateProgress();
                updateButtons();
            }       
    }

    $(document).off("click", ".next").on("click", ".next", function () {
        let playerName = $('input#playerName').val().trim();
        let imageUpload = $('input#imageUpload').val().trim();
        let checkedInput = $('.form-card .position-options input:checked');
        let cropbutton = $('#crop-button[style="display: none;"]').length
        let flag = $('div#step3 .main_badge .selected')
        let check_Box = $('div#step3 input:checked').length
        const batch = $('div#step2 .main_changes .selected').length
        // let allFilled = true;
        // $('#step2 .attributes-grid .attribute-input input[type="number"]').each(function () {
        //   if ($(this).val().trim() === '') {
        //   allFilled = false;
        //   return false;
        //   }
        // });
      // if(currentStep === 1){
      //   if (playerName && imageUpload && checkedInput.length && cropbutton) {
      //     update_class()
      //   } else {
      //       alert('Please fill in all details before proceeding.');
      //   }
      // }
      // else if(currentStep === 2 ){
      //   if(flag.length){
      //       update_class()
      //   }else{
      //      alert('Please fill details before proceeding.');
      //   }
      // }
      //  else if(currentStep === 3 ){
      //   if(check_Box && allFilled){
      //       update_class()
      //   }else{
      //      alert('Please fill details before proceeding.');
      //   }
      // }
        // update_class()
       
      function mobile_update(){             
          console.log(previousCurrentStep,'previousCurrentStep',currentStep,'currentStep')
          if(previousCurrentStep >= 3){           
           if(currentStep === 1){
              if (checkedInput.length) {
                 previousCurrentStep++ 
                update_class()
              } else {
                  alert('Please fill in all details before proceeding.');
              }
           }  
           else if(currentStep === 2 ){
              if(batch){
                 previousCurrentStep++ 
                  update_class()
              }else{
                alert('Please fill details before proceeding.');
              }
            } 
            else if(currentStep === 3 ){
              if(flag.length){
                 previousCurrentStep++ 
                  update_class()
              }else{
                alert('Please fill details before proceeding.');
              }
            }
            else if(currentStep === 4 ){
              const rating = $('.rating-input input[type="number"]').val();
              if (rating && parseFloat(rating) !== 0) {
                  previousCurrentStep++ 
                  update_class();
              } else {
                  alert('Please fill details before proceeding.');
              }
            }
          }else{
            previousCurrentStep++ 
              if(previousCurrentStep === 1) {
                  $('.prev').hide();
                  $('button.Return_product').show();
              }else {
                  $('.prev').show();
                  $('button.Return_product').hide();
              }
              $('.mobile_steps').removeClass('activated');
              $('.mobile_step_' + previousCurrentStep).addClass('activated');          
          }  
      }
       if (window.innerWidth <= 767) {
       if(previousCurrentStep===1){
        if($('input#playerName').val().trim().length){
         mobile_update()     
        }else{
        alert('Please fill details before proceeding.');
        }
       }else if(previousCurrentStep===2){
        if(imageUpload && cropbutton){
         mobile_update()     
        }else{ 
        alert('Please fill details before proceeding.');
        }
       }
       else if(previousCurrentStep===3){
         if(checkedInput.length){
         mobile_update()     
        }else{
        alert('Please fill details before proceeding.');
        }
       }
       else if(previousCurrentStep > 3){
         mobile_update()   
       }      
         
       }else{      
       if(currentStep === 1){
        if (playerName && imageUpload && checkedInput.length && cropbutton) {
          update_class()
        } else {
            alert('Please fill in all details before proceeding.');
        }
      }
      else if(currentStep === 2 ){
        if(batch){
            update_class()
        }else{
          alert('Please fill details before proceeding.');
        }
      } 
      else if(currentStep === 3 ){
        if(flag.length){
            update_class()
        }else{
          alert('Please fill details before proceeding.');
        }
      }
       else if(currentStep === 4 ){
         const rating = $('.rating-input input[type="number"]').val();
        if (rating && parseFloat(rating) !== 0) {
            update_class();
        } else {
            alert('Please fill details before proceeding.');
        }
      }
       }
      
        
    });
    
    $('.prev').click(function () {
      if(window.innerWidth <= 767){
            previousCurrentStep--   
            if(previousCurrentStep>=3){
              currentStep--    
            }           
             console.log(previousCurrentStep,'previousCurrentStep',currentStep,'currentStep')
            $('.step').removeClass('active');
            $('#step' + currentStep).addClass('active');
            updateProgress();
            updateButtons();               
           $('.mobile_steps').removeClass('activated');
           $('.mobile_step_' + previousCurrentStep).addClass('activated');                          
      }else{
        if (currentStep > 1) {     
            currentStep--;
            $('.step').removeClass('active');
            $('#step' + currentStep).addClass('active');
            updateProgress();
            updateButtons();
        }
      }       
    });
    updateProgress();
    updateButtons();
});
//tabs for step 1
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".position-tab");
  const contents = document.querySelectorAll(".position-options");
  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      tabs.forEach((t) => t.classList.remove("active"));
      this.classList.add("active");
      const selectedTab = this.textContent.trim();
      contents.forEach((content) => {
        if (content.getAttribute("data-tab-content") === selectedTab) {
          content.style.display = "flex";
        } else {
          content.style.display = "none";
        }
      });
    });
  });

  // Initialize - Show only the active tab content
  contents.forEach((content) => {
    if (content.getAttribute("data-tab-content") !== "Defence") {
      content.style.display = "none";
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll("#step2 .tab");
    const badgeOptions = document.querySelectorAll(".main_changes .badge-option");
    const searchInput = document.querySelector("#step2 .search-input");
    const scrollArrows = document.querySelectorAll(".scroll-arrow");
    const tabScroll = document.querySelector(".tab-scroll");
    const canvasBadgeImage = document.getElementById('canvas-badge-img'); 
    const hiddenInput = document.getElementById("selectedClubBadge");
    tabs.forEach(tab => {
        tab.addEventListener("click", function () {
            document.querySelector(".tab.active").classList.remove("active");
            this.classList.add("active");
            badgeOptions.forEach(option => {
                option.style.display = option.getAttribute("data-tab-content") === String(this.textContent).trim() ? "flex" : "none";
            });
        });
    });
    badgeOptions.forEach(option => {
        option.style.display = option.getAttribute("data-tab-content") === document.querySelector("#step2 .tab.active").textContent.trim() ? "flex" : "none";
    });
    searchInput.addEventListener("input", function () {
        const searchValue = this.value.toLowerCase();
        badgeOptions.forEach(options => {
                const text = options.textContent.toLowerCase();
                options.style.display = text.includes(searchValue) ? "flex" : "none";
            
        });
    });
    scrollArrows.forEach(arrow => {
        arrow.addEventListener("click", function () {
            const direction = this.classList.contains("left") ? -200 : 200;
            tabScroll.scrollBy({ left: direction, behavior: "smooth" });
        });
    });
});
// step 3 search and tab
document.addEventListener("DOMContentLoaded", function () {
    const step3 = document.getElementById("step3");
    if (!step3) return;
    const tabs = document.querySelectorAll("#step3 .tab");
    const badgeOptions = document.querySelectorAll(".main_badge .badge-option")
    const searchInput = step3.querySelector("#step3 .search-input");
    const scrollArrows = step3.querySelectorAll(".scroll-arrow");
    const tabScroll = step3.querySelector(".tab-scroll");
    badgeOptions.forEach(option => {
        option.style.display = option.getAttribute("data-tab-content") === document.querySelector("#step3 .tab.active").textContent.trim() ? "flex" : "none";
    });
    tabs.forEach(tab => {
      tab.addEventListener("click", function () {
          document.querySelector(".tab.active").classList.remove("active");
          this.classList.add("active");
          badgeOptions.forEach(option => {
              option.style.display = option.getAttribute("data-tab-content") === String(this.textContent).trim() ? "flex" : "none";
          });
      });
    });
    searchInput.addEventListener("input", function () {
        const searchValue = this.value.toLowerCase();
        badgeOptions.forEach(options => {
          const text = options.textContent.toLowerCase();
          options.style.display = text.includes(searchValue) ? "flex" : "none";
        });
    });
    scrollArrows.forEach(arrow => {
        arrow.addEventListener("click", function () {
            const direction = this.classList.contains("left") ? -200 : 200;
            tabScroll.scrollBy({ left: direction, behavior: "smooth" });
        });
    });
});
//step3 selected country flag value 
// document.addEventListener("DOMContentLoaded", function () {
//   const badgeOptions = document.querySelectorAll("#step2 .badge-option");
//   const hiddenInput = document.getElementById("selectedClubBadge");
//   badgeOptions.forEach((badge) => {
//     badge.addEventListener("click", function () {
//       const badgeName = this.textContent.trim();
//       hiddenInput.value = badgeName;
//       badgeOptions.forEach((b) => b.classList.remove("selected"));
//       this.classList.add("selected");
//     });
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  const badgeOptions = document.querySelectorAll("#step3 .badge-option");
  const hiddenInput = document.getElementById("selectedCountryFlag");
  badgeOptions.forEach((badge) => {
    badge.addEventListener("click", function () {
      const badgeName = this.textContent.trim();
      hiddenInput.value = badgeName;
      badgeOptions.forEach((b) => b.classList.remove("selected"));
      this.classList.add("selected");
    });
  });
});


//step4 rating updates
$(document).ready(function() {
    function updateRatings() {
        let pac = parseInt($('input[name="properties[PAC]"]').val()) || 0;
        let dri = parseInt($('input[name="properties[DRI]"]').val()) || 0;
        let sho = parseInt($('input[name="properties[SHO]"]').val()) || 0;
        let def = parseInt($('input[name="properties[DEF]"]').val()) || 0;
        let pas = parseInt($('input[name="properties[PAS]"]').val()) || 0;
        let phy = parseInt($('input[name="properties[PHY]"]').val()) || 0;        
        let overall = Math.round((pac + dri + sho + def + pas + phy) / 6);
        let suggested1 = Math.round(overall * 0.95);
        let suggested2 = overall;
        let suggested3 = Math.round(overall * 1.05);
        $('input[name="properties[final rating]"]').val(overall).trigger('input').trigger('change');
        $('.rating-input input').val(overall);
        $('.rating-circle').eq(0).text(suggested1);
        $('.rating-circle').eq(1).text(suggested2);
        $('.rating-circle').eq(2).text(suggested3);
    }    
    $('.attribute-input input').on('input', function() {
        updateRatings();
    });    
    updateRatings();
});
$(document).ready(function () {
  $('ul.size-buttons li').on('click', function () {
    setTimeout(function () {
      var newVariantId = $('select[name="id"]').val();
      if (!newVariantId) return;
      $('a[data-customize-product-link]').each(function () {
        var $this = $(this);
        var currentHref = $this.attr('href');
        var cleanHref = currentHref.replace(/([&?])variant=\d+/, '');
        var separator = cleanHref.includes('?') ? '&' : '?';
        var updatedHref = cleanHref + separator + 'variant=' + newVariantId;
        $this.attr('href', updatedHref);
      });
    }, 100);
  });
});

 function limitToTwoDigits(input) {
    if (input.value.length > 2) {
      input.value = input.value.slice(0, 2);
    }
  }

async function cartFetch(variantId) {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    const matchedItem = cart.items.find(item => item.variant_id === Number(variantId));
    if (matchedItem) {
    let canvass = document.getElementById("customCanvas");
    let canvasBase64 = canvass ? canvass.toDataURL("image/png") : "";
    document.querySelector('img.cart_properties_base64').setAttribute('src',canvasBase64)
    document.querySelector(".main-product-item .card__size").innerHTML = matchedItem.title;
    let formetmoney = matchedItem.price/100
    document.querySelector(".card__price.price-or-amoount").innerHTML = `${formetmoney} ${cart.currency}`;
    document.querySelector(".fb_subtotal-box span.price.price-or-amoount").innerHTML = `${formetmoney} ${cart.currency}`;
      
      
    document.querySelector('.tingle-modal.tingle-modal--noOverlayClose.tingle-modal--visible.tingle-modal--overflow').style.display = 'block'
    }
  } catch (error) {
    console.error("Error fetching cart:", error);
    document.querySelector(".custom_atc").innerHTML = "Failed to fetch cart.";
  }
}
   document.querySelectorAll('#step4 .custom-checkbox').forEach((insuranceChecked) => {
      insuranceChecked.addEventListener('click', function (e) {
          document.querySelectorAll('#step4 .custom-checkbox').forEach((checkremove) => {
              checkremove.classList.remove('checked');
          });
          this.classList.add('checked');
      });
  });



async function urlToFile(url, filename, mimeType) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, { type: mimeType });
}


$(".custom_atc").on("click",async function (e) {
  e.preventDefault();
  if (!$('.final_review input').is(':checked')) {
    alert("Please check Final Review box before continuing.");
    return;
  }
  let urlParams = new URLSearchParams(window.location.search);
  let variantId = urlParams.get("variant");
  if (!variantId) return;

  let urrl = $('.club_badge.selected img').attr('src');
  let urrl2 = $('.country-item.selected img').attr('src');
  const [clubbadgefile, countryfile] = await Promise.all([
      urlToFile(urrl, "badge.png", "image/png"),
      urlToFile(urrl2, "badge2.png", "image/png")
  ]);



  document.querySelector('.custom_atc svg').style.display = 'block';
  let playerName = $("input[name='properties[Player Name]']").val();
  let position = $(".position-radio:checked").val()
  // let countryFlag = $("input[name='properties[country flag]']").val();
  // let clubBadge = $("input[name='properties[Club Badge]']").val();
  let PAC = $("input[name='properties[PAC]']").val();
  let DRI = $("input[name='properties[DRI]']").val();
  let SHO = $("input[name='properties[SHO]']").val();
  let DEF = $("input[name='properties[DEF]']").val();
  let PAS = $("input[name='properties[PAS]']").val();
  let PHY = $("input[name='properties[PHY]']").val();

  let DIV = $("input[name='properties[DIV]']").val();
  let HAIN = $("input[name='properties[HAIN]']").val();
  let KIC = $("input[name='properties[KIC]']").val();
  let REF = $("input[name='properties[REF]']").val();
  let SPE = $("input[name='properties[SPE]']").val();
  let POS = $("input[name='properties[POS]']").val();                      
  let final_rating = $("input[name='properties[final rating]']").val();
  let insuranceProduct = $('#step4 span.custom-checkbox.checked').attr('variand-insurance');
  const canvas = document.getElementById("customCanvas");
  const canvasBase64 = canvas ? canvas.toDataURL("image/png") : "";
  function base64ToFile(base64, filename) {
  const [meta, data] = base64.split(',');
  const mime = meta.match(/:(.*?);/)[1];
  const binary = atob(data);
  const array = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i);
  }
  return new File([array], filename, { type: mime });
  }
  let canvasFile = base64ToFile(canvasBase64, "card-preview.png");
  let formData = new FormData();
  formData.append("items[0][id]", variantId);
  formData.append("items[0][quantity]", 1);
  formData.append("items[0][properties][Player Name]", playerName);
  formData.append("items[0][properties][Position]", position);
  formData.append("items[0][properties][Country Flag]", countryfile);
  formData.append("items[0][properties][Club Badge]", clubbadgefile);
  function appendIfExists(key, value) {
    if (value !== undefined && value !== null && value !== "") {
      formData.append(key, value);
    }
  }
  appendIfExists("items[0][properties][PAC]", PAC);
  appendIfExists("items[0][properties][DRI]", DRI);
  appendIfExists("items[0][properties][SHO]", SHO);
  appendIfExists("items[0][properties][DEF]", DEF);
  appendIfExists("items[0][properties][PAS]", PAS);
  appendIfExists("items[0][properties][PHY]", PHY);
  appendIfExists("items[0][properties][DIV]", DIV);
  appendIfExists("items[0][properties][HAIN]", HAIN);
  appendIfExists("items[0][properties][KIC]", KIC);
  appendIfExists("items[0][properties][REF]", REF);
  appendIfExists("items[0][properties][SPE]", SPE);
  appendIfExists("items[0][properties][POS]", POS);
  


  
  formData.append("items[0][properties][Final Rating]", final_rating);
  formData.append("items[0][properties][Preview Image]", canvasFile);
  formData.append("items[0][properties][Uploaded Image]", UploadedselectedFile);
  formData.append("items[0][properties][Processed Image]", Backgroundremove);
  
 
  if (insuranceProduct) {
    formData.append("items[1][id]", insuranceProduct);
    formData.append("items[1][quantity]", 1);
  }

  fetch("/cart/add.js", {
    method: "POST",
    body: formData
  })
  .then(response => response.json())
  .then(async (response) => {
    await cartFetch(variantId);
    document.querySelector('.custom_atc svg').style.display = 'none';
  })
  .catch(error => {
    console.error("Error adding to cart:", error);
  });
});
